import React from "react";
import { Bar } from "react-chartjs-2";
import { ToolTipCreator } from "../../../../../../../helpers/ToolTipCreator";

export const BudgetIncomeChart = ({ chartData }) => {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const reversedChartData = chartData ? [...chartData].reverse() : [];
  // console.log("chartData",chartData,reversedChartData)
  const chartData1 = {
    // labels: reversedChartData ? reversedChartData.map(item => monthNames[parseInt(item.month.split("-")[1]) - 1])  : [], // Extract month names
    labels: reversedChartData
      ? reversedChartData.map((item) => {
          const [year, month] = item.month.split("-");
          return `${monthNames[parseInt(month) - 1]} ${year}`; // Format as "Month Year"
        })
      : [],
    datasets: [
      {
        label: "Income",
        backgroundColor: "#09A84D",
        borderColor: "#09A84D",
        borderWidth: 1,
        data: reversedChartData
          ? reversedChartData.map((item) => parseFloat(item.total_income))
          : [],
      },
      {
        label: "Expenses",
        backgroundColor: "#2A3DA3",
        borderColor: "#2A3DA3",
        borderWidth: 1,
        data: reversedChartData
          ? reversedChartData.map((item) =>
              Math.abs(parseFloat(item.total_expenses))
            )
          : [],
      },
    ],
  };

  return (
    <div>
      <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
        <div className="budget-chart-title">Income vs Expenses</div>
        <ToolTipCreator name={"Budget_Income_Expenses"}/>
      </div>
      <div className="budget-chart-conatiner">
        <Bar
          data={chartData1}
          //   height={80}
          options={{
            legend: {
              display: true,
            },

            scales: {
              xAxes: [
                {
                  gridLines: {
                    color: "rgba(0, 0, 0, 0)",
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                    callback: function (value) {
                      return new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(value);
                    },
                  },
                  gridLines: {
                    color: "rgba(0, 0, 0, 0)",
                  },
                },
              ],
            },
            animation: {
              onComplete: function () {
                const chart = this.chart; // Access the chart instance
                const ctx = chart.ctx; // Get the drawing context
                ctx.save(); // Save the initial state of the canvas

                ctx.font = "12px Arial";
                ctx.fillStyle = "black"; // Set text color
                ctx.textAlign = "center";
                ctx.textBaseline = "bottom";

                chart.data.datasets.forEach((dataset, datasetIndex) => {
                  const meta = chart.getDatasetMeta(datasetIndex);

                  meta.data.forEach((bar, index) => {
                    const value = dataset.data[index];

                    ctx.fillText(
                      new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(value),
                      bar.x, // X-coordinate of the bar
                      bar.y - 5 // Y-coordinate slightly above the bar
                    );
                  });
                });

                ctx.restore(); // Restore the initial state of the canvas
              },
            },
            plugins: {},
          }}
        />
      </div>
    </div>
  );
};
